import ApiService from "./ApiService";

class FichaInfoService {
  static async getFichaInfoData(hash, query_params) {
    const { df, lang } = query_params;
    let composedURL = `/api3/edited_ficha/${hash}`;
    if (df) {
      composedURL += `?df=${df}&lang=${lang || "en-US"}`;
    }
    const response = await ApiService.get(composedURL, query_params);
    return response;
  }
  static async getOpennaventData(hash, query_params) {
    const { df, lang } = query_params;
    let composedURL = `/portals/opennavent/api3/posting/${hash}/public`;
    if (df) {
      composedURL += `?df=${df}&lang=${lang || "en-US"}`;
    }
    const response = await ApiService.get(composedURL, query_params);
    return response;
  }
  static async getCustomAgentBranch({ agentID, host }) {
    const jwt = localStorage.getItem("jwt");
    const composedURL = `/api3/users/${agentID}`;
    const response = await ApiService.get(composedURL, { jwt }, host);
    return response;
  }
  static async saveProfileEdition({ hash, data, TOKKO_HOST }) {
    const jwt = localStorage.getItem("jwt");
    const composedURL = `/api3/edited_ficha/${hash}`;
    const response = await ApiService.post(composedURL, data, jwt, TOKKO_HOST);
    return response;
  }
  static async sendFeedback({ hash, data, TOKKO_HOST }) {
    const composedURL = `/api3/edited_ficha/${hash}/feedback_reaction`;
    const response = await ApiService.post(composedURL, data, null, TOKKO_HOST);
    return response;
  }
}

export default FichaInfoService;
